import { useTranslation, useProperty } from '@eti/providers';
import {
  EXCLUDE_SELF_TRANSFER,
  NUMBER_OF_STOPS,
} from '../../../../../constants/searchFiltersConstants';
import RadioFilter from './RadioFilter';
import ExcludeSelfTransfer from './ExcludeSelfTransfer';
import type { Filters } from './MobileFilters';

const getOption = (label: string, value: string, name: string) => ({
  dataTestId: `${NUMBER_OF_STOPS}-${name}`,
  id: `${NUMBER_OF_STOPS}_${label}`,
  label,
  value,
});

interface NumberOfStopsProps {
  className?: string;
  isInitiallyExpanded: boolean;
  isToggleable: boolean;
  onFilter: (filterOptions: { [key: string]: string | null }) => void;
  selectedFilters?: Filters | null;
}

const NumberOfStops = ({
  className,
  isInitiallyExpanded,
  isToggleable,
  onFilter,
  selectedFilters,
}: NumberOfStopsProps) => {
  const { p } = useProperty();
  const { t } = useTranslation();

  const options = [
    getOption(t('Result.SearchFilters.NumberOfStops.Direct.Button'), '0', 'direct'),
    getOption(t('Result.SearchFilters.NumberOfStops.Max1.Button'), '1', 'max'),
    getOption(t('Result.SearchFilters.NumberOfStops.All.Button'), '-1', 'all'),
  ];

  const selectedValue = selectedFilters?.[NUMBER_OF_STOPS] || '-1';

  const handleReset = () => {
    onFilter({
      [NUMBER_OF_STOPS]: null,
      [EXCLUDE_SELF_TRANSFER]: null,
    });
  };

  const handleSelfTransfer = () => {
    onFilter({
      [EXCLUDE_SELF_TRANSFER]: selectedFilters?.[EXCLUDE_SELF_TRANSFER] ? null : 'true',
    });
  };

  const isSelfTransferChecked = Boolean(selectedFilters?.[EXCLUDE_SELF_TRANSFER]);

  const isSelfTranserFilterEnabled = p('Result.Filter.SelfTransfer.Enabled');

  return (
    <RadioFilter
      className={className}
      isInitiallyExpanded={isInitiallyExpanded}
      isSelected={selectedValue !== '-1' || isSelfTransferChecked}
      isToggleable={isToggleable}
      label={t('Air.Filter.Group.Stops')}
      name={NUMBER_OF_STOPS}
      onFilter={onFilter}
      onReset={handleReset}
      options={options}
      selectedValue={selectedValue ?? ''}
    >
      {isSelfTranserFilterEnabled && (
        <ExcludeSelfTransfer handleChange={handleSelfTransfer} isChecked={isSelfTransferChecked} />
      )}
    </RadioFilter>
  );
};

export default NumberOfStops;
